import { ref } from "vue";
import { defineStore } from "pinia";
import { Channel } from "../services/channel";

class WmtsChannel extends Channel {
  constructor(onReceived) {
    super("Geo::WmtsChannel");
    this.callbacks = {};
  }

  async tiles(viewbox, layer, zoom, callback) {
    const uuid = crypto.randomUUID();
    this.#callbackWithUuid(uuid, callback);
    this.perform("tiles", {
      uuid: uuid,
      layer: layer,
      zoom: zoom,
      viewbox: viewbox
    });
  }

  async layers(callback) {
    const uuid = crypto.randomUUID();
    this.#callbackWithUuid(uuid, callback);
    this.perform("layers", { uuid: uuid });
  }

  async zooms(callback) {
    const uuid = crypto.randomUUID();
    this.#callbackWithUuid(uuid, callback);
    this.perform("zooms", { uuid: uuid });
  }

  #callbackWithUuid(uuid, callback) {
    this.callbacks[uuid] = (data) => {
      delete this.callbacks[data.uuid];
      callback(data.value);
    };
  }

  received(data) {
    if (data.uuid && this.callbacks[data.uuid]) {
      this.callbacks[data.uuid](data);
    }
  }
}

export const useWmtsStore = defineStore('wmts', () => {
  const channel = new WmtsChannel();
  channel.connect();

  async function tiles(viewbox, layer=null, zoom=null, callback) {
    return channel.tiles(viewbox, layer, zoom, callback);
  }

  async function layers(callback) {
    return channel.layers(callback);
  }

  async function zooms(callback) {
    return channel.zooms(callback);
  }

  return {
    layers,
    tiles,
    zooms
  };
});
